exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.agreement-modal-error {\n  position: relative;\n  top: 40%;\n}\n.agreement-modal-content {\n  text-align: left;\n  padding: 50px 20px 0;\n  overflow-y: scroll;\n  height: 100%;\n}\n.agreement-modal-content > :last-child {\n  margin-bottom: 120px;\n}\n.agreement-modal-content p {\n  margin-block-start: 1em;\n  margin-block-end: 1em;\n  word-break: break-word;\n}\n.agreement-modal-content ol, .agreement-modal-content ul {\n  margin-block-start: 1em;\n  margin-block-end: 1em;\n  padding-inline-start: 20px;\n}", ""]);

// exports
